import { warningColor } from '@/scss/variables';
import { KksState } from 'types';

export const KKSStatesColorTags: Record<string, string> = {
  [KksState.DMS_CONFIRMED]: `background-color: color-mix(in srgb, ${warningColor}, transparent 84%); color: ${warningColor}`,
  [KksState.NON_CONFORMING]:
    'background-color: color-mix(in srgb, var(--p-red-500), transparent 84%); color: var(--p-red-500)',
  [KksState.PLANNED]: `background-color: color-mix(in srgb, ${warningColor}, transparent 84%); color: ${warningColor}`,
  [KksState.DMS_PROPOSED]:
    'background-color: color-mix(in srgb, var(--p-indigo-500), transparent 84%); color: var(--p-indigo-500)',
  [KksState.SAP_PM]:
    'background-color: color-mix(in srgb, var(--p-emerald-500), transparent 84%); color: var(--p-emerald-500)',
  [KksState.UNDEFINED]:
    'background-color: color-mix(in srgb, var(--p-red-500), transparent 84%); color: var(--p-red-500)',
  [KksState.DDP_PROPOSED]:
    'background-color: color-mix(in srgb, var(--p-pink-500), transparent 84%); color: var(--p-pink-500)',
};
